export const fallbackLocale = "de"
